export default function getTagsFromModel(pageModel) {
    if (!pageModel) return {tags: null, title: null};

    const metaTags = pageModel._metaTags || null;
    const tagMatches = metaTags ? metaTags.match(/<meta(.*?)>/igm) : [];
    const titleMatches = metaTags ? metaTags.match(/<title>(.*?)<\/title>/igm) : [];

    const tags = [];
    if (tagMatches && tagMatches.length) {
        tagMatches.forEach((t) => {
            const tag = {};

            let name = t.match(/name="(.*?)"/);
            if (name && name[1]) {
                name = name[1];
                tag.name = name;
            }

            let property = t.match(/property="(.*?)"/);
            if (property && property[1]) {
                property = property[1];
                tag.property = property;
            }

            let content = t.match(/content="(.*?)"/);
            if (content && content[1]) {
                content = content[1];
                tag.content = content;
            }

            tags.push(tag);
        });
    }

    let title = pageModel._title || '';
    if (titleMatches && titleMatches.length) {
        title = titleMatches[0].replace('<title>', '').replace('</title>', '');
    }

    return {tags, title};
}
